<template>
	<div class="h-100">
		<router-view></router-view>
		<!-- 메세지 박스 플러그인 -->
		<sf-message-box :okLabel="getMessage_('SWCC000560')" :cancelLabel="getMessage_('SWCC000561')" />
		<!-- 로딩 창 플러그인 -->
		<sf-loading />
		<!-- 세션 연장 팝업 창 -->
		<screen-counter-modal ref="sessionModal" />
	</div>
</template>

<script>
//Vue 프로젝트 최 상단 Component, 모든 Layout과 Component는 App Component에 포함되어 있음
import { rootComputed, rootMethods } from '@/store/common/helpers';
import ScreenCounterModal from '@/views/Pages/Modal/ScreenCounterModal.vue';

import DefaultLayout from '@/views/Layout/DefaultLayout';
import MenuLayout from '@/views/Layout/Main/MenuLayout';
import ScreenLayout from '@/views/Layout/Main/ScreenLayout';

export default {
	components: { ScreenCounterModal },

	//App이 created 되는 경우: 브라우저 최초 접속, 브라우저 새로고침 한 경우
	created() {
		document.body.setAttribute('data-theme', this.topSkin); //store의 색상 테마로 CSS 적용
		document.body.setAttribute('font-theme', this.font); //store의 폰트 테마로 CSS 적용
	},

	//App이 mounted 될 때
	mounted() {
		// window.addEventListener('beforeunload', this.unLoadEvent); //브라우저 나갈 때 이벤트 등록
		window.addEventListener('mousemove', this.initScreenTimer); //사용자 마우스 이동 감지 이벤트 등록

		//세션 관리 중일 경우(로그인 후 브라우저 새로고침 된 경우)
		if (this.sessionState) {
			this.sessionStart(); //세션 타이머 재시작
			this.screenStart(); //화면 Timer 시작
		}

		//로그아웃 웹소켓 리스너 등록
		this.subscribeLogout();

		if (this.userMessageList.length > 0 && !this.userMessage.size) {
			this.setLangMessage_();
		}
		if (this.menuList.length > 0 && !this.menuMap.size) {
			this.setMenuMap_();
		}

		this.createRoute();
	},

	//App이 beforeDestroy 될 때
	beforeDestroy() {
		// window.removeEventListener('beforeunload', this.unLoadEvent); //브라우저 나갈 때 이벤트 제거
		window.removeEventListener('mousemove', this.initScreenTimer); //사용자 마우스 이동 감지 이벤트 제거

		// this.sessionStop(); //세션 Timer
		// this.screenStop(); //화면 Timer 중지
	},

	data() {
		return {
			timer: null, //세션 관리할 세션 Timer
			screenTimer: null //사용자 움직임을 감시할 화면 Timer
		};
	},
	computed: {
		...rootComputed
	},
	watch: {
		//store의 사용자의 세션 관리 여부 감시
		sessionState(val) {
			//세션 관리를 시작하면
			if (val) {
				this.sessionStart(); //세션 Timer 시작
				this.screenStart(); //화면 Timer 시작
				this.$refs.sessionModal.initModal(); //세션 연장 여부 팝업창 초기화
			}
			//세션 관리를 중지하면
			else {
				this.sessionStop(); //세션 Timer 중지
				this.screenStop(); //화면 Timer 중지
			}
		},

		//store의 사용자의 색상 테마 감시
		topSkin(val) {
			document.body.setAttribute('data-theme', val); // 색상 테마 변경
		},

		//store의 사용자의 폰트 테마 감시
		font(val) {
			document.body.setAttribute('font-theme', val); // 폰트 테마 변경
		},

		//store의 사용자 정보 감시
		getUser_(val, oldVal) {
			//로그아웃 한 경우
			if (this.$sf_isEmptyObj(val)) {
				this.sessionStop(); //세션 Timer 중지
				this.screenStop(); //화면 Timer 중지
			}
			// 로그인한 경우
			else if (val && val.userId !== oldVal.userId && val.userId !== '') {
				this.sessionStart(); //세션 Timer 시작
				this.screenStart(); //화면 Timer 시작
				this.$refs.sessionModal.initModal(); //세션 연장 여부 팝업창 초기화
			}
		},

		//store의 사용자 세션 초기화까지 남은 시간 감시
		sessionCounter(val) {
			//남은 시간이 0초 미만일 경우
			if (val < 0) {
				this.logout(); // 로그아웃
			}
		},

		//store의 장기간 미사용으로 인해 자동 로그아웃까지 남은 시간 감시
		screenCounter(val) {
			//남은 시간이 0초 미만일 경우
			if (val < 0) {
				this.logout(); // 로그아웃
			}
		}
	},

	methods: {
		...rootMethods,

		//브라우저를 빠져나갈 때(새로고침/종료)의 이벤트 함수
		// unLoadEvent(event) {
		// 	if (this.sessionState) {
		// 		this.logout();
		// 	}
		// 	event.returnValue = '';
		// 	return '';
		// },

		//store의 메뉴 정보를 이용해 route 생성하는 함수
		createRoute() {
			if (this.menuMap.size > 0) {
				let route = {
					path: '/',
					name: 'Layout',
					redirect: '/login',
					component: DefaultLayout,
					children: []
				};

				for (let menu of this.menuMap.values()) {
					//tab을 사용하지않는 화면일 경우 자식 Routing 방식 사용
					//자식 Routing의 Name은 메뉴 Name에 Screen을 붙여서 관리
					//자식 Route에 보여줄 화면 은 scrId url Parameter를 통해 받아서 관리/Display
					let children = [];
					children.push({ path: `${menu.scrUrl}/:scrId`, name: `${menu.scrName}Screen`, component: ScreenLayout });

					//메뉴 정보와 생성한 자식 Route 정보를 route.children에 추가
					route.children.push({ path: menu.scrUrl, name: menu.scrName, component: MenuLayout, children });
				}

				this.$router.addRoute(route); //메뉴 정보들을 통해 생성한 Route 정보를 router에 추가
			}
		},

		//세션 관리 Timer 시작
		sessionStart() {
			//Timer가 없는 경우
			if (!this.timer) {
				// 세션 Timer 생성(1초 주기)
				this.timer = setInterval(() => {
					this.sessionTimer_();
				}, 1000);
			}
		},

		//세션 관리 Timer 중지
		sessionStop() {
			//세션 Timer 초기화
			clearInterval(this.timer);
			this.timer = null;
		},

		//화면 Timer 시작
		screenStart() {
			//Timer가 없는 경우
			if (!this.screenTimer) {
				// 세션 Timer 생성(1초 주기)
				this.screenTimer = setInterval(() => {
					this.screenTimer_();
				}, 1000);
			}
		},

		//화면 Timer 중지
		screenStop() {
			//화면 Timer 초기화
			clearInterval(this.screenTimer);
			this.screenTimer = null;
		},

		//화면 Timer 값 초기화: 사용자 움직임 감지
		initScreenTimer() {
			if (this.screenTimer) {
				this.defaultAssign_({ key: 'screenCounter', value: this.screenTimeout });
			}
		},

		//로그아웃
		logout() {
			//세션 감시중이 아닌데 호출 되었을 경우 탈출
			if (!this.sessionState) return;

			this.sessionStop(); //세션 Timer 중지
			this.screenStop(); //화면 Timer 중지

			this.$sf_toggleLoading(true);

			//사용자 로그아웃 Action 호출
			this.logout_()
				.then(header => {
					//사용자 로그아웃 성공 시
					if (header.code === 0) {
						this.$sf_removeAll(); //Tab 메뉴 내용 삭제
						this.$sf_showMessage({
							title: '로그아웃 되었습니다.',
							icon: 'cancel',
							closeFn: () => this.$router.push('/login').catch(() => {}) //로그아웃 안내 메세지 버튼 클릭시 로그인 페이지로 이동
						});
					} else {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
					this.$router.push('/login').catch(() => {}); //에러 발생시 즉시 로그인 페이지로 이동
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//로그아웃 웹소켓 리스너 등록
		subscribeLogout() {
			this.listener = new this.$sf_topicListener({ 
				topic: 'logout', 
				onMessage: this.onLogout, 
				// target: process.env.VUE_APP_WS_TARGET 
			});
		},

		//로그아웃 웹소켓 수신
		onLogout({ sessionId }) {
			try {
				if (window.atob(this.sessionId) === sessionId) {
					this.setInitStore_(); //store 초기화
					this.sessionStop(); //세션 Timer 중지
					this.screenStop(); //화면 Timer 중지
					this.$sf_removeAll(); //열려 있는 tab 전체 삭제
					this.$router.push('/login').catch(() => {}); //로그인 페이지로 이동
					this.$sf_toast({ type: 'info', message: this.getMessage_('SWCC000715') }); //다국어: 중복 로그인으로 인해 로그아웃되었습니다.
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		}
	}
};
</script>
<style></style>
